import { createContext } from 'react';

export type CrossBrowserState = Readonly<{
  isDirty: boolean;
  isLocked: boolean;
}>;

export const CrossBrowserContext = createContext<CrossBrowserState>({
  isDirty: false,
  isLocked: false,
});
